import { NULL_TAG } from '@racemap/utilities/consts/events';
import classnames from 'classnames';
import type { JSX } from 'react';
import { AnimatedChevronIcon } from 'src/components/BasicComponents/Icons';
import { ALL_TAG } from 'src/lib/player/constants';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';
import type { ItemStyle } from './types';

export type StarterGroupHeaderProps = {
  style: ItemStyle;
  tagKey: string;
  tagValue: string;
  isOpen: boolean;
  starterCount: number;
  allHidden: boolean;
  onToggle: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function StarterGroupHeader({
  style,
  tagKey,
  tagValue,
  isOpen,
  starterCount,
  allHidden,
  onToggle,
  onHide,
  onUnhide,
}: StarterGroupHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header starter-list-group-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        <AnimatedChevronIcon isOpen={isOpen} />
        &nbsp;
        <div className="starter-list-header-item-label">
          {tagKey === ALL_TAG ? (
            t('tags.all')
          ) : (
            <>
              {t(`tags.${tagKey}`, tagKey)}:&nbsp;
              {tagValue === NULL_TAG ? t('tags.none') : tagValue}
            </>
          )}
          &nbsp;<span className="starter-list-header-item-info">{starterCount}</span>
        </div>
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
